import defaultAttributes from '../defaultAttributes';

const Vibrate = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M2 8l2 2-2 2 2 2-2 2' }],
    ['path', { d: 'M22 8l-2 2 2 2-2 2 2 2' }],
    ['rect', { x: '8', y: '5', width: '8', height: '14', rx: '1' }],
  ],
];

export default Vibrate;
